import { React } from "react";   

const QRcodeWelcomeMessageSV = () => {
    return (
        <h4 className="instructions">
            Kära deltagare, du kan lösa in denna QR-kod för att bli en 
            av de första pilottestare av GlucoNutris-appen när den kommer 
            att vara i drift, förhoppningsvis någon gång under sommaren 2023. 
            För att kunna göra detta, skicka oss en kopia av din QR-kod med 
            e-post genom att klicka på "Contact" längst ner på sidan och vi 
            kommer att kontakta dig inom kort. Du kan få tillgång till din QR-kod 
            genom att Logga in på ditt konto eller så kan du ta en skärmkopia och 
            spara den. Än en gång, tack för din värdefulla tid. GlucoNutris-teamet.

        </h4>


    )
    
}
export default QRcodeWelcomeMessageSV